import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'root/view/base';

var Asana = View.extend({
    className: 'box-medium box-integration',

    events: {
        'click .activate:not(.disabled)'   : 'activate',
        'click .deactivate:not(.disabled)' : 'deactivate',
        'click .settings:not(.disabled)'   : 'editSettings',
        'click .test:not(.disabled)'       : 'test'
    },

    dom_handlers: {
        activate: function(e) {
            if (!Cache.account.hasFeature('integrations') || Cache.account.get('is_expired')) {
                Modals.unlockFeature('Upgrade your plan to start using Integrations.');
            } else {
                Modals.activateAsana();
            }
        },

        deactivate: function(e) {
            Modals.deactivateAsana();
        },

        editSettings: function(e) {
            Modals.editAsana();
        },

        test: function(e) {
            this.$el.addClass('testing');

            Cache.app.request({
                action: 'integration/testAsana',
                context: this,
                success: function() {
                    UI.success('A test task has been created in your Asana project');
                },
                complete: function() {
                    this.$el.removeClass('testing');
                }
            });
        }
    },

    event_handlers: {
        onConnect: function(model) {
            if (model.get('project_id') !== Cache.default_project_id) {
                return;
            }

            this.model = model;
            this.render();
        },

        onDisconnect: function(model) {
            if (model.get('project_id') !== Cache.default_project_id) {
                return;
            }

            this.model = undefined;
            this.render();
        }
    },

    initialize: function() {
        this.model = Cache.integration_asana.findWhere({project_id: Cache.default_project_id});

        this.listenTo(Cache.integration_asana, 'change', this.render);
        this.listenTo(Cache.integration_asana, 'add',    this.event_handlers.onConnect);
        this.listenTo(Cache.integration_asana, 'remove', this.event_handlers.onDisconnect);
    },

    isConnected: function() {
        return this.model && this.model.isConnected() ? true : false;
    },

    isDisabled: function() {
        if (this.isConnected()) {
            var connected_app = Cache.connected_app_oauth.get(this.model.get('app_id'));

            if (this.model.get('is_disabled')) {
                return true;
            } else if (connected_app && connected_app.isDisabled()) {
                return true;
            }
        }

        return false;
    },

    isRecommended: function() {
        return Cache.account.get('onboarding').account_setup_integration === 'asana_pending';
    },

    getStatusBadge: function() {
        var badge = '';

        if (this.isDisabled()) {
            badge = '<span class="badge-warning-invert badge-small tooltip" data-title="Authentication failed. Please reconnect your Asana integration."><i class="fa-solid fa-circle-exclamation"></i> Disabled</span>';
        } else if (this.isConnected()) {
            badge = '<span class="badge-success-invert badge-small">Active</span>';
        } else if (this.isRecommended()) {
            badge = '<span class="badge-primary-invert badge-small">Recommended</span>';
        }

        return badge;
    },

    render: function() {
        var content = '';

        content += '<div class="thumbnail">' +
                        '<img src="/image/asana_small.png">' +
                    '</div>' +
                    '<div class="content">' +
                        '<h3>Asana' + this.getStatusBadge() + '</h3>' +
                        '<div>Create tasks in Asana when Feedback is created.</div>' +
                    '</div>' +
                    (this.isConnected() ?

                    (Cache.app.isAdmin() ?
                    '<div class="action">' +
                        '<div class="button-dropdown">' +
                            '<button class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown">' +
                                    '<li class="deactivate">Disconnect</li>' +
                                    '<li class="test">Test</li>' +
                                    '<li class="separator"></li>' +
                                    '<li class="settings">Settings</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                    '</div>' : '')

                    :

                    '<div class="action"><button type="button" class="activate small tertiary min">Connect</button></div>');

        this.$el.html(content);

        this.$el.toggleClass('connected', this.isConnected());

        return this;
    }
});

export default Asana;
